import { useContext, useMemo } from 'react'
import { IntakeContext } from 'context/IntakeContext'
import { useFormDebounce } from 'hooks/useFormDebounce'

import { Box, Typography } from '@mui/material'
import { useModal } from 'components/modals'

import { v4 as uuidv4 } from 'uuid'

import { AssetInnerTable, AccountRow, CallToActionRow } from 'atoms/AssetsTable'

import { selectData } from 'layouts/onboarding'

import LifeInsuranceAssets from './LifeInsuranceList'

const dollarFormat = Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  maximumFractionDigits: 0,
})

const OnboardingLifeInsurance = ({ demoMode }) => {
  return (
    <Box sx={{ textAlign: 'left' }} pb={3}>
      <Box mb={1}>
        <Typography variant="h4" fontSize={{ xs: '20px', sm: '24px' }}>
          Let&apos;s talk about Private Life Insurance!
        </Typography>
      </Box>
      <Typography variant="body1" fontSize={{ xs: '16px', sm: '20px' }}>
        Tell us about the Private Life Insurance you have:
      </Typography>

      <LifeInsuranceAssets />
    </Box>
  )
}

export default OnboardingLifeInsurance
